import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ToastComponent } from '../../../shared/toast/toast.component';
import { ApplicationListModel } from '../../../../core/models/customer/application-list.model';
import { PatientsService } from '../../../../core/services/patient/patient.service';
import { FullscreenOverlayComponent } from '../../../components/fullscreen-overlay/fullscreen-overlay.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApplicationCode } from '../../../../../enums/application-code.enum';
import { ToastService } from '../../../../core/services/toast.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-create-edit-conclusion-option',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FullscreenOverlayComponent,
    TranslateModule,
  ],
  templateUrl: './create-edit-conclusion-option.component.html',
  styleUrl: './create-edit-conclusion-option.component.scss',
})
export class CreateEditConclusionOptionComponent {
  conclusionOptionForm: FormGroup;
  applications: ApplicationListModel[] = [
    {
      id: 1,
      name: 'Dermatology',
      code: 'DERM',
      applicationCode: ApplicationCode.DERM,
    },
    {
      id: 2,
      name: 'Osas',
      code: 'OSAS',
      applicationCode: ApplicationCode.OSAS,
    },
    {
      id: 3,
      name: 'Diabet',
      code: 'DIAB',
      applicationCode: ApplicationCode.DIAB,
    },
  ];
  isOverlayLoading: boolean = false;
  conclusionOptionCode: string = '';
  conclusionOptionId: string | null = '';
  conclusionAddOptionId: string | null = '';
  editApplicationCode: number = 0;
  addConclusionOptionApp: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private patientService: PatientsService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private translate: TranslateService
  ) {
    this.conclusionOptionForm = this.fb.group({
      titleEng: ['', Validators.required],
      titleDutch: ['', Validators.required],
      titleTurkish: ['', Validators.required],
      titleFrench: ['', Validators.required],
      titleGerman: ['', Validators.required],
      titleSpanish: ['', Validators.required],
      titleItalian: ['', Validators.required],
      titleDanish: ['', Validators.required],
      titleSwedish: ['', Validators.required],
      titleNorwegian: ['', Validators.required],
      titleFinnish: ['', Validators.required],
      conclusionOptionContents: this.fb.array([
        this.createConclusionOptionContent(),
      ]),
    });
  }

  ngOnInit(): void {
    this.conclusionOptionCode = this.route.snapshot.paramMap.get('code')!;

    const type = this.route.snapshot.url[0]?.path;
    if (type === 'add') {
      this.conclusionAddOptionId = this.route.snapshot.paramMap.get('id');
      this.addConclusionOptionApp = this.route.snapshot.paramMap.get('app')!;
    } else if (type === 'edit') {
      this.conclusionOptionId = this.route.snapshot.paramMap.get('id');
    }
    // Edit Conclusion
    if (this.conclusionOptionId) {
      this.patientService
        .getConclusionOptionDetail(this.conclusionOptionId)
        .subscribe({
          next: (res) => {
            this.editApplicationCode = res?.applicationCode;
            this.conclusionOptionForm = this.fb.group({
              titleEng: ['', Validators.required],
              titleDutch: ['', Validators.required],
              titleTurkish: ['', Validators.required],
              titleFrench: ['', Validators.required],
              titleGerman: ['', Validators.required],
              titleSpanish: ['', Validators.required],
              titleItalian: ['', Validators.required],
              titleDanish: ['', Validators.required],
              titleSwedish: ['', Validators.required],
              conclusionOptionContents: this.fb.array([
                this.createConclusionOptionContent(),
              ]),
            });

            this.conclusionOptionForm.patchValue({
              titleEng: res.titleEng,
              titleDutch: res.titleDutch,
              titleTurkish: res.titleTurkish,
              titleFrench: res.titleFrench,
              titleGerman: res.titleGerman,
              titleSpanish: res.titleSpanish,
              titleItalian: res.titleItalian,
              titleDanish: res.titleDanish,
              titleSwedish: res.titleSwedish,
              titleNorwegian: res.titleNorwegian,
            });

            const conclusionOptionContentsArray = this.conclusionOptionContents;

            conclusionOptionContentsArray.at(0).patchValue({
              titleEng: res.titleEng || '',
              titleDutch: res.titleDutch || '',
              titleTurkish: res.titleTurkish || '',
              titleFrench: res.titleFrench || '',
              titleGerman: res.titleGerman || '',
              titleSpanish: res.titleSpanish || '',
              titleItalian: res.titleItalian || '',
              titleDanish: res.titleDanish || '',
              titleSwedish: res.titleSwedish || '',
              titleNorwegian: res.titleNorwegian || '',
              conclusionTextEng: res.conclusionTextEng || '',
              conclusionTextDutch: res.conclusionTextDutch || '',
              conclusionTextFrench: res.conclusionTextFrench || '',
            });
          },
          error: (error) => {
            console.log('error :>> ', error);
          },
        });
    }
  }

  get applicationTitle(): string | undefined {
    return (
      this.applications.find(
        (app: any) => app.code === this.conclusionOptionCode
      )?.name ||
      this.applications.find(
        (app: any) => app.applicationCode === this.editApplicationCode
      )?.name
    );
  }

  get conclusionOptionContents(): FormArray {
    return this.conclusionOptionForm.get(
      'conclusionOptionContents'
    ) as FormArray;
  }

  createConclusionOptionContent(): FormGroup {
    return this.fb.group({
      titleEng: ['', Validators.required],
      conclusionTextEng: ['', Validators.required],
      titleDutch: ['', Validators.required],
      conclusionTextDutch: ['', Validators.required],
      titleTurkish: ['', Validators.required],
      conclusionTextTurkish: ['', Validators.required],
      titleFrench: ['', Validators.required],
      conclusionTextFrench: ['', Validators.required],
      titleGerman: ['', Validators.required],
      conclusionTextGerman: ['', Validators.required],
      titleSpanish: ['', Validators.required],
      conclusionTextSpanish: ['', Validators.required],
      titleItalian: ['', Validators.required],
      conclusionTextItalian: ['', Validators.required],
      titleDanish: ['', Validators.required],
      conclusionTextDanish: ['', Validators.required],
      titleSwedish: ['', Validators.required],
      conclusionTextSwedish: ['', Validators.required],
      titleNorwegian: ['', Validators.required],
      conclusionTextNorwegian: ['', Validators.required],
      titleFinnish: ['', Validators.required],
      conclusionTextFinnish: ['', Validators.required],
    });
  }

  addConclusionOptionContent(): void {
    this.conclusionOptionContents.push(this.createConclusionOptionContent());
  }

  removeConclusionOptionContent(index: number): void {
    this.conclusionOptionContents.removeAt(index);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.conclusionOptionForm.get(controlName);
    return control ? control.invalid && control.touched : false;
  }

  // Save, edit or add form
  onSubmit(): void {
    this.isOverlayLoading = true;
    // Create conclusion option
    if (this.conclusionOptionCode) {
      const formValue = this.conclusionOptionForm.value;
      const code = this.applications.find(
        (application: any) => application.code === this.conclusionOptionCode
      );
      const formData = {
        conclusionOption: {
          titleEng: formValue.titleEng,
          titleDutch: formValue.titleDutch,
          titleTurkish: formValue.titleTurkish,
          titleFrench: formValue.titleFrench,
          titleGerman: formValue.titleGerman,
          titleSpanish: formValue.titleSpanish,
          titleItalian: formValue.titleItalian,
          titleDanish: formValue.titleDanish,
          titleSwedish: formValue.titleSwedish,
          titleNorwegian: formValue.titleNorwegian,
          titleFinnish: formValue.titleFinnish,
          conclusionOptionContents: formValue.conclusionOptionContents.map(
            (content: any) => ({
              titleEng: content.titleEng,
              titleDutch: content.titleDutch,
              titleTurkish: content.titleTurkish,
              titleFrench: content.titleFrench,
              titleGerman: content.titleGerman,
              titleSpanish: content.titleSpanish,
              titleItalian: content.titleItalian,
              titleDanish: content.titleDanish,
              titleSwedish: content.titleSwedish,
              titleNorwegian: content.titleNorwegian,
              titleFinnish: content.titleFinnish,
              conclusionTextEng: content.conclusionTextEng,
              conclusionTextDutch: content.conclusionTextDutch,
              conclusionTextTurkish: content.conclusionTextTurkish,
              conclusionTextFrench: content.conclusionTextFrench,
              conclusionTextGerman: content.conclusionTextGerman,
              conclusionTextSpanish: content.conclusionTextSpanish,
              conclusionTextItalian: content.conclusionTextItalian,
              conclusionTextDanish: content.conclusionTextDanish,
              conclusionTextSwedish: content.conclusionTextSwedish,
              conclusionTextNorwegian: content.conclusionTextNorwegian,
              conclusionTextFinnish: content.conclusionTextFinnish,
              applicationCode: code?.applicationCode,
            })
          ),
        },
      };
      this.patientService.createConclusionOption(formData).subscribe({
        next: () => {
          this.toastService.showToast(
            this.translate.instant('conclusionOptionCreatedSuccessfully'),
            'success'
          );
        },
        complete: () => {
          setTimeout(() => {
            this.isOverlayLoading = false;
            this.router.navigate(['/conclusion-options/list']);
          }, 2000);
        },
      });
    }
    // Edit conclusion option
    else if (this.conclusionOptionId) {
      const conclusionOptionContents = this.conclusionOptionContents.value;
      const form = {
        id: this.conclusionOptionId,
        titleEng: conclusionOptionContents[0]?.titleEng,
        titleDutch: conclusionOptionContents[0]?.titleDutch,
        titleTurkish: conclusionOptionContents[0]?.titleTurkish,
        titleFrench: conclusionOptionContents[0]?.titleFrench,
        titleGerman: conclusionOptionContents[0]?.titleGerman,
        titleSpanish: conclusionOptionContents[0]?.titleSpanish,
        titleItalian: conclusionOptionContents[0]?.titleItalian,
        titleDanish: conclusionOptionContents[0]?.titleDanish,
        titleSwedish: conclusionOptionContents[0]?.titleSwedish,
        titleNorwegian: conclusionOptionContents[0]?.titleNorwegian,
        titleFinnish: conclusionOptionContents[0]?.titleFinnish,
        conclusionTextEng: conclusionOptionContents[0]?.conclusionTextEng || '',
        conclusionTextDutch:
          conclusionOptionContents[0]?.conclusionTextDutch || '',
        conclusionTextTurkish:
          conclusionOptionContents[0]?.conclusionTextTurkish || '',
        conclusionTextFrench:
          conclusionOptionContents[0]?.conclusionTextFrench || '',
        conclusionTextGerman:
          conclusionOptionContents[0]?.conclusionTextGerman || '',
        conclusionTextSpanish:
          conclusionOptionContents[0]?.conclusionTextSpanish || '',
        conclusionTextItalian:
          conclusionOptionContents[0]?.conclusionTextItalian || '',
        conclusionTextDanish:
          conclusionOptionContents[0]?.conclusionTextDanish || '',
        conclusionTextSwedish:
          conclusionOptionContents[0]?.conclusionTextSwedish || '',
        conclusionTextNorwegian:
          conclusionOptionContents[0]?.conclusionTextNorwegian || '',
        conclusionTextFinnish:
          conclusionOptionContents[0]?.conclusionTextFinnish || '',
      };
      this.patientService
        .editConclusionOptionContent(this.conclusionOptionId, form)
        .subscribe({
          next: () => {
            this.toastService.showToast(
              this.translate.instant('conclusionOptionEditedSuccessfully'),
              'success'
            );
          },
          complete: () => {
            setTimeout(() => {
              this.isOverlayLoading = false;
              this.router.navigate(['/conclusion-options/list']);
            }, 2000);
          },
        });
    }
    // Add conclusion option
    else if (this.conclusionAddOptionId) {
      const formValue = this.conclusionOptionForm.value;
      const code = this.applications.find(
        (application: any) => application.code === this.addConclusionOptionApp
      );
      const formData = {
        conclusionOptionId: this.conclusionAddOptionId,
        conclusionOptionContents: formValue.conclusionOptionContents.map(
          (content: any) => ({
            titleEng: content.titleEng,
            titleDutch: content.titleDutch,
            titleTurkish: content.titleTurkish,
            titleFrench: content.titleFrench,
            titleGerman: content.titleGerman,
            titleSpanish: content.titleSpanish,
            titleItalian: content.titleItalian,
            titleDanish: content.titleDanish,
            titleSwedish: content.titleSwedish,
            titleNorwegian: content.titleNorwegian,
            titleFinnish: content.titleFinnish,
            conclusionTextEng: content.conclusionTextEng,
            conclusionTextDutch: content.conclusionTextDutch,
            conclusionTextTurkish: content.conclusionTextTurkish,
            conclusionTextFrench: content.conclusionTextFrench,
            conclusionTextGerman: content.conclusionTextGerman,
            conclusionTextSpanish: content.conclusionTextSpanish,
            conclusionTextItalian: content.conclusionTextItalian,
            conclusionTextDanish: content.conclusionTextDanish,
            conclusionTextSwedish: content.conclusionTextSwedish,
            conclusionTextNorwegian: content.conclusionTextNorwegian,
            conclusionTextFinnish: content.conclusionTextFinnish,
            applicationCode: code?.applicationCode,
          })
        ),
      };
      console.log('formData :>> ', formData);
      this.patientService
        .addConclusionOption(this.conclusionAddOptionId, formData)
        .subscribe({
          next: () => {
            this.toastService.showToast(
              this.translate.instant('conclusionOptionAddedSuccessfully'),
              'success'
            );
          },
          complete: () => {
            setTimeout(() => {
              this.isOverlayLoading = false;
              this.router.navigate(['/conclusion-options/list']);
            }, 2000);
          },
        });
    }
  }
}
